<ejs-sidebar id="sidebar-menu" #sidebarInstance type='Over' [width]='width' [position]='position'
             style="visibility: hidden" [enableGestures]="false" [showBackdrop]=true>

  <div class="offcanvas-close mt-n1 pr-5" style="float:right; padding: 48px;">
    <a href="javascript:;" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_panel_close"
       (click)="closeSidebar()">
      <i class="ki ki-close icon-xs text-muted"></i>
    </a>
  </div>

  <div class='p-15'>
    <h2 *ngIf="!companyRoleInput">Add Company Role</h2>
    <h2 *ngIf="companyRoleInput">Update Company Role</h2>

    <form id="formId" [formGroup]="companyRoleForm" #formDir="ngForm" class="form-horizontal" novalidate=""
          style="margin-top: 16px;">

      <div class="form-group sf-outline-input mb-10" [class.hide-label]="companyRoleForm.controls.company_role_parent_code.value == ''">
        <ejs-dropdowntree formControlName="company_role_parent_code" id='company_role_parent_code' allowMultiSelection='false' sortOrder="Ascending"
                          [fields]='companyRoleFields' placeholder='Parent Company Role' floatLabelType="Auto" cssClass="e-filled"
                          (blur)="companyRoleForm.controls.company_role_parent_code.markAsTouched()"></ejs-dropdowntree>
        <div>Note: If a parent role isn't selected, the new company role will be added as a parent</div>
      </div>


      <div class="form-group sf-outline-input mb-10">
        <ejs-textbox id="company_role_name" placeholder="Company Role Name *" cssClass="e-filled"
                     formControlName="company_role_name" floatLabelType="Auto"
                     (blur)="companyRoleForm.controls.company_role_name.markAsTouched()"
        ></ejs-textbox>
        <div *ngIf="companyRoleForm.controls.company_role_name.errors">
          <div
            *ngIf="companyRoleForm.controls.company_role_name.errors.required && companyRoleForm.controls.company_role_name.touched"
            class="e-error">
            Company Role Name is required.
          </div>
        </div>
      </div>


      <div *ngIf="companyRoleForm.invalid" class="e-error">Please fill all fields</div>
      <div *ngIf="error$ | async as error" class="e-error">{{error.error.message}}</div>

      <div class="my-10 pb-20">
        <button id="resetbtn"
                class="btn btn-outline-secondary text-uppercase font-weight-bold px-15 py-5 float-right btn-block mb-5"
                type="button" (click)="clearForm()"
                data-ripple="true">Clear
        </button>
        <button id="addSubmit"
                class="btn btn-primary text-uppercase font-weight-bold px-15 py-5 float-right btn-block" type="submit"
                (click)="onAddUpdateCompanyType(companyRoleForm)" [disabled]="formSent" data-ripple="true">
          <span *ngIf="!companyRoleInput">Add Company Role</span>
          <span *ngIf="companyRoleInput">Update Company Role</span>

        </button>
        <!--        <button *ngIf="companyTypeInput" id="updateSubmit"-->
        <!--                class="btn btn-primary text-uppercase font-weight-bolder px-15 py-5 float-right btn-block" type="submit"-->
        <!--                (click)="onAddUpdateActivityType(activityTypeForm, true)" [disabled]="formSent" data-ripple="true">-->
        <!--          Update Activity Type-->
        <!--        </button>-->
      </div>
    </form>
  </div>
</ejs-sidebar>
